import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { useThemeObserver, token } from '@atlaskit/tokens';
import { CHART_COLUMN_OVERLAY_Z_INDEX } from '../../../../../styles';

type Props = {
	columnPositions: [number, number][];
	startPosition: number;
	endPosition: number;
};

function ColumnsOverlay({ columnPositions, endPosition, startPosition }: Props) {
	const { colorMode } = useThemeObserver();
	const isDarkMode = colorMode === 'dark';
	return (
		<Container>
			{endPosition < 100 && <GreyOverlay left={endPosition} right={0} isDarkMode={isDarkMode} />}
			{startPosition > 0 && (
				<GreyOverlay left={0} right={100 - startPosition} isDarkMode={isDarkMode} />
			)}
			{/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
			{columnPositions.map(([left, right]: [any, any], index) => (
				<Column key={index} left={left} right={right} />
			))}
		</Container>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	position: 'absolute',
	display: 'flex',
	width: '100%',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: CHART_COLUMN_OVERLAY_Z_INDEX,
	pointerEvents: 'none',
});

interface StyledDivProps {
	left: number;
	right: number;
	isDarkMode?: boolean;
}

const secondaryBorder = `1px solid ${token('color.border', colors.N40)}`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Column = styled.div<StyledDivProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	left: (props) => `${props.left.toFixed(2)}%`,

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: (props) => `${props.right.toFixed(2)}%`,
	position: 'absolute',
	top: 0,
	bottom: 0,
	flex: '0 0 auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:last-of-type)': {
		borderRight: secondaryBorder,
	},
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GreyOverlay = styled.div<StyledDivProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	left: (props) => `${props.left.toFixed(2)}%`,

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: (props) => `${props.right.toFixed(2)}%`,
	position: 'absolute',
	top: 0,
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: (props) => (props.isDarkMode ? colors.DN200A : colors.N20A),
});

export default ColumnsOverlay;
